// extracted by mini-css-extract-plugin
export var border = "_s-7";
export var brand = "_s-r";
export var button = "_s-j";
export var center = "_s-9";
export var centered = "_s-5";
export var closeButton = "_s-b";
export var disabledWrapper = "_s-k";
export var error = "_s-n";
export var extraLarge = "_s-4";
export var extraSmall = "_s-1";
export var fill = "_s-g";
export var footer = "_s-f";
export var footerAction = "_s-h";
export var footerButtons = "_s-i";
export var header = "_s-6";
export var icon = "_s-m";
export var info = "_s-q";
export var inline = "_s-8";
export var large = "_s-3";
export var main = "_s-c";
export var modal = "_s-0";
export var neutral = "_s-s";
export var noPadding = "_s-e";
export var none = "_s-t";
export var scrollable = "_s-d";
export var small = "_s-2";
export var success = "_s-p";
export var tight = "_s-l";
export var titleIcon = "_s-a";
export var warn = "_s-o";